import React from "react";
import { Globals as OldGlobals } from "../../global/Globals";
import FileUploader from "../../components/FileUploader/FileUploader";
import { infoIcon } from "../NewBrief/BriefUtils";
import { useLanguage } from '../../context/Languagecontext';
import FallBackLabel from '../../global/Globals_Eng.json';

const CompanyInformation = () => {
  const { Globals ,languages, setLanguages } = useLanguage();
  const handleInfoButton =()=>{

  }
  return (
    <div className="apply-brief-company-info-container">
      <label className="brief-basic-details-text">
        {Globals.APPLY_BRIEF.COMPANY_INFORMATION}
      </label>
      <div className="brief-apply3-container">
        {/* Showreel Upload */}
        <div className="brief-apply3-card">
          <label className="brief-apply3-title">
            {Globals.APPLY_BRIEF.SHOW_REEL}
            <span className="required"> *</span>
          </label>
          <FileUploader
            onFileUpload={() => {}}
            className="brief-apply3-file-wrapper"
          />
        </div>

        {/* Certificate Upload */}
        <div className="brief-apply3-card">
          <label className="brief-apply3-title">
            {Globals.APPLY_BRIEF.CERTIFICATE}
            <span className="required"> *</span>
          </label>
          <FileUploader
            onFileUpload={() => {}}
            className="brief-apply3-file-wrapper"
          />
        </div>

        {/* Regulatory Documentation Upload */}
        <div className="brief-apply3-card">
          <label className="brief-apply3-title">
            {Globals.APPLY_BRIEF.REGULAROTY}
            <span className="required"> *</span>
          </label>
          <FileUploader
            onFileUpload={() => {}}
            className="brief-apply3-file-wrapper"
          />
        </div>
      </div>
    </div>
  );
};

export default CompanyInformation;
 